<template>
     <div class="container">
        <br>
            <div class="has-text-left has-text-white top20 is-size-2"><b>CONNECTION REQUEST</b></div>
           
           <div v-if="!notA && loaded" class="has-text-white">
                <div><b>{{item.name}}</b> has invited you to connect on MiiMu.  Please choose an option below. If you choose to decline, this choice will not be share with the user who invited you.</div>
    
                <div class="top40">
                    <button class="button is-coolGreen" @click="act('a')">ACCEPT</button>&nbsp;
                    <button class="button" @click="act('d')">DECLINE</button>
                </div>
           </div>
           <div v-if="notA">
               No Authorization
           </div>
     </div>

</template>


<script>

import { AZEventBus } from '../components/AZEventBus'

export default{

    data: function(){
        return {
            inited: false,
            id: this.$route.query.id,
            noId: false,
            item: {name: ''},
            notA: false,
            loaded: false
        }
    },

    mounted: function(){
        var self = this

        function init(){
            function w(d){

                self.loaded = true
                if(d.r == 'Not Authorized'){
                    self.notA = true
                    return
                }
                self.item = d.r
            }
            function n(){
            
            }

            if(self.id != undefined)
                self.$root.app.apiClient.get('subs/conn/connectid/' + self.id, {}, w, n)
            else
                noId = true
        }

        if(self.$root.app.doneFederating){
            self.inited = true
            init();
        }

        AZEventBus.$once('onFederate', msg => {
            if(self.inited == false)
                    init();
        });
    },

    methods: {
        act: function(a){

            var self = this
            
            function w(d){
                if(d.r == 'ok'){
                    self.$router.push('/connects')
                    self.$root.app.unRead -= 1
                    self.$root.app.nots.find(e => {
                        return e.id = self.id
                    }).markAsRead = 2
                }
            }

            function n(){
                self.$root.app.showModalOK({message: 'There was an error updating your data.'})
            }

            if(self.id != undefined)
                this.$root.app.apiClient.put(`subs/conn/connectid`, {id: self.id, a: a}, w, n)
        }   
    }


}


</script>